import React from 'react';

import { useAtom } from 'jotai';

import { useIndexedMTA } from './hooks';
import { track } from '../../../../utils/tracking';
import { analysisTypeAtom, analysisSearchAtom } from '../../../atoms';
import { DERIVED_TIERS, DEFAULT_DERIVED_TIERS } from '../../../constants/tiers';
import { formatName } from '../../../utils/valueFormatter';
import { StyledDropdown } from '../../index';
import TiersRollupFilter from '../RollupFilter';
import { useTiers } from '../RollupFilter/hooks';

const analysisOptions = ['tiers', ...DERIVED_TIERS].map(text => ({
  text: formatName(text),
  value: text.split(' ').join('_'),
}));

const AnalysisDropdown = ({ analysisType, options, searchValue, onChange, rawData, hierarchy, clearAnalysis }) => {
  const { clearFilters } = useTiers();
  const { channelOptions, platformOptions, adTypeOptions, audienceTargetOptions } = options;
  const dropdownOptions = {
    channel: channelOptions,
    platform: platformOptions,
    ad_type: adTypeOptions,
    audience_targeting: audienceTargetOptions,
  };

  if (dropdownOptions[analysisType]) {
    clearFilters();
    return (
      <StyledDropdown
        value={searchValue}
        onChange={onChange}
        options={dropdownOptions[analysisType]}
        placeholder={`${DEFAULT_DERIVED_TIERS[analysisType]} contains`}
        multiple
        clearable
        search
      />
    );
  }
  if (analysisType === 'tiers') {
    clearAnalysis();
    return <TiersRollupFilter {...{ rawData, hierarchy }} />;
  }
  return null;
};

const DerivedTiersFilter = ({ rawData, tiersData, hierarchy }) => {
  const [analysisType, setAnalysisType] = useAtom(analysisTypeAtom);
  const [searchValue, setSearchValue] = useAtom(analysisSearchAtom);

  const handleAnalysis = (evt, { value }) => {
    setAnalysisType(value);
    setSearchValue('');
  };

  const clearAnalysis = () => {
    setSearchValue('');
  };

  const handleSearch = (evt, { value }) => {
    track(`crosschannel.filter.adv.${analysisType}`);
    setSearchValue(value);
  };

  const { channelOptions, platformOptions, adTypeOptions, audienceTargetOptions } = useIndexedMTA(rawData);

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', paddingBottom: 10 }}>
        <StyledDropdown value={analysisType} options={analysisOptions} onChange={handleAnalysis} style={{ width: 200 }} />
        {/* <StyledDropdown value="is" options={[{ text: 'is', value: 'is' }]} disabled /> */}
        <div style={{ flex: 0.8 }}>
          <AnalysisDropdown
            {...{
              analysisType,
              options: { channelOptions, platformOptions, adTypeOptions, audienceTargetOptions },
              searchValue,
              onChange: handleSearch,
              rawData: tiersData, hierarchy,
              clearAnalysis,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DerivedTiersFilter;
